<canvas
  baseChart
  [labels]="doughnutChartLabels"
  [datasets]="doughnutChartDatasets"
  [options]="doughnutChartOptions"
  [legend]="true"
  [type]="'doughnut'">
</canvas>
